export const GLOBAL_STATE = 'CourseCreate'

export const COURSE = 'course'
export const COURSE_CREATE = 'courseCreate'
export const COURSE_LIST = 'courseList'
export const COURSE_ALL = 'courseAll'
